import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender } from './Icon';

const PersonMinusIcon = forwardRef<SVGSVGElement, ComponentProps<typeof Icon>>(
  (props, ref) => (
    <Icon data-testid="personMinus" ref={ref} {...props}>
      <path d="M14,11.9a4.58,4.58,0,1,1,4.58-4.58A4.58,4.58,0,0,1,14,11.9Zm0-7.65A3.08,3.08,0,1,0,17,7.32,3.08,3.08,0,0,0,14,4.25Zm8.8,16.25A5.71,5.71,0,0,0,17,14.79H10.78A5.71,5.71,0,0,0,5.07,20.5a.75.75,0,0,0,1.5,0,4.22,4.22,0,0,1,4.21-4.21H17a4.22,4.22,0,0,1,4.21,4.21.75.75,0,0,0,1.5,0ZM8.58,12.32a.74.74,0,0,0-.75-.75H2.2a.75.75,0,0,0,0,1.5H7.83A.75.75,0,0,0,8.58,12.32Z" />
    </Icon>
  ),
) as IconWithRender;

PersonMinusIcon.displayName = 'PersonMinusIcon';
PersonMinusIcon.renderIcon = (props) => <PersonMinusIcon {...props} />;
export default PersonMinusIcon;
